import { createAction, props } from '@ngrx/store';
import { TraineeOverview } from '../../../shared/services/api/models/trainee-list-response';

export const getTraineeListSuccess = createAction(
  '[Trainee API] Get Trainee List Success',
  props<{ traineesOverview: TraineeOverview }>(),
);

export const getTraineeListFailed = createAction(
  '[Trainee API] Get Trainee List Failed',
  props<{ error: string }>(),
);

export const inviteTraineeSuccess = createAction(
  '[Trainee API] Trainee Invite Success',
);

export const inviteTraineeFailed = createAction(
  '[Trainee API] Trainee Invite Failed',
  props<{ error: string }>(),
);

export const emailValidationSuccess = createAction(
  '[Identity API] Email Validation Success',
);
export const emailValidationFailed = createAction(
  '[Identity API] Email Validation Failed',
  props<{ error: string }>(),
);

export const deleteTraineeSuccess = createAction(
  '[Identity API] Delete Trainee Success',
);
export const deleteTraineeFailed = createAction(
  '[Identity API] Delete Trainee Failed',
  props<{ error: string }>(),
);

export const resendTraineeInviteSuccess = createAction(
  '[Identity API] Resend Trainee Invite Success',
);
export const resendTraineeInviteFailed = createAction(
  '[Identity API] Resend Trainee Invite Failed',
  props<{ error: string }>(),
);

export const DownloadCertificateSuccess = createAction(
  '[Identity API] Download Trainee Certificate Success',
);
export const DownloadCertificateFailed = createAction(
  '[Identity API] Download Trainee Certificate Failed',
  props<{ error: string }>(),
);
